import CancelDocumentButton from '../Common/CancelDocumentButton';
import { useState, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.css';
//import InvoiceForm from '../InvoiceFormx';
import { Badge, Button, Card, CardBody,  Col, Container, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner, UncontrolledDropdown } from 'reactstrap';
import { FaBoxOpen, FaCheckCircle, FaEdit,  FaFileInvoice, FaFilePdf, FaFilter, FaInfo, FaMoneyBillWave, FaPlus, FaSearch, FaUpload, FaUser } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { receiptNoteActions } from '../../sagas/receiptNoteSlice';
import InvoiceForm from './InvoiceForm';
import { formatPrice } from '../../helpers/utility';
import "jspdf-autotable";
import { productActions } from '../../sagas/productSlice';
import { generateReceptionLikePdfMake } from '../../helpers/generateReceptionDoc';
import { supplierActions } from '../../sagas/supplierSlice';
import Select from "react-select";
import { useNavigate } from 'react-router-dom';
import { RECEPTION_FORM_PAGE } from '../../routes/routeConstants';
import DocumentPagination from '../Common/DocumentPagination';
import '../Common/DocumentList.css';
import './CompactPurchases.css';

const ReceptionPage = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [checkedReceptions, setCheckedReceptions] = useState([]);
    const [invoice, setInvoice] = useState(null); // State to hold the invoice object
    const [showInvoiceModal, setShowInvoiceModal] = useState(false); // State to control the invoice modal
    const { company } = useSelector(state => state.auth);
    const { receiptNotes, isLoading, totalPages, totalElements, pageNumber, pageSize } = useSelector((state) => state.receiptNote);
    const { suppliers, loading: suppliersLoading } = useSelector(state => state.suppliers);
    const { loading } = useSelector((state) => state.invoiceSupplier);
    const [selectedSupplier, setSelectedSupplier] = useState('');
    const now = new Date();
    const todayDate = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const tomorrowDate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    const pad = (n) => n.toString().padStart(2, '0');
    const formatDate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
    const formatMonth = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
    const getMonthRange = (monthValue) => {
        const [year, month] = monthValue.split('-').map(Number);
        const firstDay = new Date(year, month - 1, 1);
        const lastDay = new Date(year, month, 0);
        return {
            dateFrom: formatDate(firstDay),
            dateTo: formatDate(lastDay)
        };
    };
    const currentMonth = formatMonth(todayDate);
    const currentMonthRange = getMonthRange(currentMonth);
    const [filters, setFilters] = useState({
        fournisseurId: null,
        month: currentMonth,
        dateFrom: currentMonthRange.dateFrom,
        dateTo: currentMonthRange.dateTo,
        query: '',
        paymentStatus: '',
        page: 0,
        size: 10
    });

    const unites = useSelector(status => status.products.unites); // Assuming you have a Redux store with unite

    const searchInputRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        let payload = {
            ...filters,
        };
        dispatch(receiptNoteActions.search(payload));
    }, [filters.fournisseurId, filters.dateFrom, filters.dateTo, filters.paymentStatus, filters.page, filters.size]);

    useEffect(() => {
        if (suppliers.length === 0) {
            // Fetch suppliers for supplier report
            const fetchSuppliers = async () => {
                dispatch(supplierActions.search({
                    query: ""
                }));
            };

            fetchSuppliers();
        }
        dispatch(productActions.findAllUnites());
    }, []);

    useEffect(() => {
        // Auto focus on mount
        searchInputRef.current?.focus();

        // Add keyboard shortcut
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                searchInputRef.current?.focus();
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, [receiptNotes]);

    const handleSupplierChange = (value) => {
        setFilters(f => ({ ...f, fournisseurId: value, page: 0 }));
    };

    const fournisseurOptions = suppliers?.map(sup => ({
        solde: sup.solde,
        totalDebit: sup.totalDebit,
        totalCredit: sup.totalCredit,
        value: sup.id,
        label: sup.typeFournisseur === 'PARTICULIER' ? `${sup.nom} ${sup.prenom} (${sup.code})` : `${sup.entreprise}(${sup.code})`,
    })) ?? [];

    const debouncedSearch = () => {
        dispatch(receiptNoteActions.search({
            ...filters,
            page: 0,
        }));
        setFilters(f => ({ ...f, page: 0 }));
    }

    const getStatusBadge = (status) => {
        switch (status) {
            case 'EN_ATTENTE':
                return <Badge color="secondary">En attente confirmation</Badge>;
            case 'REFUSE':
                return <Badge color="danger">Annulée</Badge>;
            case 'VALIDE':
                return <Badge color="success">Confirmée</Badge>;

            default:
                return <Badge color="light">-</Badge>;
        }
    };

    const getPaymentStatus = (note) => {
        const montantRegle = Number(note.montantRegle || 0);
        const montantTotal = Number(note.montantTotalTTC || 0);
        if (note.estRegle || (montantTotal > 0 && montantRegle >= montantTotal)) return 'PAYE';
        if (montantRegle > 0) return 'PARTIEL';
        return 'IMPAYE';
    };

    const getPaymentBadge = (note) => {
        switch (getPaymentStatus(note)) {
            case 'PAYE':
                return <Badge color="success">{t('reglement.paye')}</Badge>;
            case 'PARTIEL':
                return <Badge color="warning">{t('reglement.partiel')}</Badge>;
            default:
                return <Badge color="danger">{t('reglement.impaye')}</Badge>;
        }
    };

    const getPaymentRowClass = (note) => {
        switch (getPaymentStatus(note)) {
            case 'PAYE':
                return 'table-success';
            case 'PARTIEL':
                return 'table-warning';
            default:
                return 'table-danger';
        }
    };

    const filteredReceiptNotes = receiptNotes.filter(note =>
        !filters.paymentStatus || getPaymentStatus(note) === filters.paymentStatus
    );
    const selectableFilteredReceiptIds = filteredReceiptNotes
        .filter(note => note.statut === 'VALIDE' && !note.facture)
        .map(note => note.id);

    const handleCheckboxChange = (noteId) => {
        setCheckedReceptions((prevChecked) => {
            if (prevChecked.includes(noteId)) {
                return prevChecked.filter((id) => id !== noteId);
            } else {
                return [...prevChecked, noteId];
            }
        });
    };

    const handleCreateInvoice = () => {
        if (checkedReceptions.length === 0) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('reception.noReceptionsSelected'),
            });
            return;
        }

        const selectedReceiptNotes = receiptNotes.filter(note =>
            checkedReceptions.includes(note.id)
        );

        // Validation: same supplier + confirmed
        const firstSupplier = selectedReceiptNotes[0].fournisseurId;
        const allSameSupplier = selectedReceiptNotes.every(n => n.fournisseurId === firstSupplier);
        const allConfirmed = selectedReceiptNotes.every(n => n.statut === 'VALIDE');

        if (!allSameSupplier) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('reception.noteFromifferentSuppliers'),
            });
            return;
        }

        if (!allConfirmed) {
            Swal.fire({
                icon: 'warning',
                title: t('common.warning'),
                text: t('reception.notAllConfirmed'),
            });
            return;
        }

        const lineMap = {};

        selectedReceiptNotes.forEach(note => {
            note.lignes.forEach(line => {

                const tva = line.tauxTVA;
                const prixTTC = Number(line.prixUnitaireTTC || 0);

                // key combines article + price
                const key = `${line.articleId}-${prixTTC}`;

                if (!lineMap[key]) {
                    lineMap[key] = {
                        articleId: line.articleId,
                        articleNom: line.articleNom,
                        unite: unites.find(u => u.code === line.unite)?.libelle,
                        prixUnitaireHT: line.prixUnitaireHT,
                        prixUnitaireTTC: prixTTC,
                        tauxTVA: tva,
                        quantite: 0,
                        montantHT: 0,
                        montantTVA: 0,
                        montantTTC: 0
                    };
                }

                // increment the values
                lineMap[key].quantite += Number(line.quantiteRecue || 0) - Number(line.quantiteGratuite || 0);

                lineMap[key].montantHT += Number(line.montantHT || 0);
                lineMap[key].montantTTC += Number(line.montantTTC || 0);
                lineMap[key].montantTVA += Number((line.montantTVA) || 0);
            });
        });


        const aggregatedLines = Object.values(lineMap);

        // ------------------------------------------
        // Global Totals
        // ------------------------------------------
        const montantHT = selectedReceiptNotes.reduce((s, l) => s + l.montantTotalHT, 0);
        const montantTVA = selectedReceiptNotes.reduce((s, l) => s + l.montantTotalTaxe, 0);
        const montantTTC = selectedReceiptNotes.reduce((s, l) => s + l.montantTotalTTC, 0);

        // ------------------------------------------
        // Receipt -> Invoice mapping
        // ------------------------------------------
        const receiptMappings = selectedReceiptNotes.map(note => ({
            id: note.id,
            numero: note.numero,
            dateReception: note.dateReception,
            montantTTC: note.montantTotalTTC
        }));

        // ------------------------------------------
        // Build final invoice object
        // ------------------------------------------
        const newInvoice = {
            dateFacture: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
            dateOperation: new Date().toLocaleDateString('en-CA', { timeZone: 'Africa/Casablanca' }),
            fournisseurId: selectedReceiptNotes[0].fournisseurId,
            fournisseurNom: selectedReceiptNotes[0].fournisseurNom,
            numeroFactfournisseur: '',
            statut: "IMPAYE",
            receiptMappings,
            lignes: aggregatedLines,
            montantRegle: selectedReceiptNotes.reduce((total, note) => total + (note.montantRegle || 0), 0),
            montantHT,
            montantTVA,
            montantTTC
        };
        setInvoice(newInvoice);
        setShowInvoiceModal(true);
    };


    const handleCloseInvoiceModal = () => {
        setShowInvoiceModal(false);
        setInvoice(null);
        setCheckedReceptions([]); // Clear checked receptions after closing the invoice modal
        let payload = {
            ...filters
        };
        dispatch(receiptNoteActions.search(payload));

    };

    if (isLoading || loading) {
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                }}
            >
                <Spinner color="primary" />
            </div>
        );
    }

    const handleShowModal = () => {
        navigate(RECEPTION_FORM_PAGE);
    };

    const handleValidate = (receiptNote) => {
        Swal.fire({
            title: t('common.confirm'),
            text: t('reception.confirmValidateMessage'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: t('reception.confirmValidate'),
            cancelButtonText: t('common.cancel')
        }).then((result) => {
            if (result.isConfirmed) {
                if (receiptNote.id > 0) {
                    dispatch(receiptNoteActions.validateReceiptNote({
                        id: receiptNote.id,
                        onSuccess: () => {
                            Swal.fire(
                                t('common.saved'),
                                t('reception.savedSuccess'),
                                'success'
                            );
                            refreshReceiptNotes();
                        },
                        onError: (error) => {
                            Swal.fire(
                                t('common.error'),
                                t('reception.saveError'),
                                'error'
                            );
                        }
                    }));
                }
            }
        });
    };

    const refreshReceiptNotes = () => {
        let payload = {
            ...filters
        };
        dispatch(receiptNoteActions.search(payload));
    };

    const clearFilters = () => {
        const monthRange = getMonthRange(currentMonth);
        setFilters({
            query: '',
            fournisseurId: null,
            month: currentMonth,
            dateFrom: monthRange.dateFrom,
            dateTo: monthRange.dateTo,
            paymentStatus: '',
            page: 0,
            size: filters.size
        });
    };

    const handleMonthChange = (monthValue) => {
        if (!monthValue) {
            setFilters(f => ({ ...f, month: '', page: 0 }));
            return;
        }

        const monthRange = getMonthRange(monthValue);
        setFilters(f => ({
            ...f,
            month: monthValue,
            dateFrom: monthRange.dateFrom,
            dateTo: monthRange.dateTo,
            page: 0
        }));
    };

    const handlePageChange = (nextPage) => {
        if (nextPage < 1 || nextPage > Math.max(totalPages, 1)) {
            return;
        }
        setFilters(f => ({ ...f, page: nextPage - 1 }));
    };



    return (
        <Container fluid className="compact-reception-list py-2">
            <Row className="mb-2 reception-list-heading">
                <Col>
                    <Card className="shadow-sm">
                        <CardBody className="d-flex justify-content-between align-items-center">
                            <h4 className="mb-0 d-flex align-items-center">
                                <FaBoxOpen className="text-primary me-2" />
                                {t('reception.title')}
                            </h4>
                            <div className="d-flex align-items-center gap-2">

                                {/* Primary actions */}
                                <Button color="primary" onClick={handleShowModal}>
                                    <FaPlus className="me-2" /> {t('reception.newReception')}
                                </Button>
                                {checkedReceptions.length > 0 && (
                                    <Button color="success" onClick={handleCreateInvoice}>
                                        <FaFileInvoice className="me-2" />
                                        {t('reception.createInvoice')}
                                    </Button>
                                )}

                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
            <Card className="shadow-sm">
                <CardBody>
                    {loading ? ( // Show spinner when loading
                        <div className="text-center py-5">
                            <Spinner color="primary" />
                            <div className="mt-2 text-muted">{t('common.loading')}</div>
                        </div>
                    ) : (
                        <>
                            <div className="filter-container mb-2">
	                                <Row className="mb-3 g-2 align-items-end doc-filter-row">
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label className="mb-1">{t('reglement.search')}</Label>
                                            <div className="input-group">
                                                <span className="input-group-text bg-light">
                                                    <FaSearch />
                                                </span>
                                                <Input
                                                    type="text"
                                                    innerRef={searchInputRef}
                                                    placeholder={t('reception.searchPlaceholder')}
                                                    value={filters.query}
                                                    onChange={e => {
                                                        const value = e.target.value.toUpperCase();
                                                        setFilters(prevFilters => ({
                                                            ...prevFilters,
                                                            query: value
                                                        }));
                                                    }}
                                                    className="text-uppercase"
                                                    style={{ textTransform: 'uppercase' }}
                                                    onKeyDown={e => {
                                                        if (e.key === 'Enter') {
                                                            debouncedSearch(e.target.value.toUpperCase());
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup>
                                            <Label for="supplierSelect" className="form-label">
                                                <FaUser className="me-1" /> Fournisseur
                                            </Label>
                                            <Select
                                                inputId="supplierSelect"
                                                options={fournisseurOptions}
                                                isLoading={suppliersLoading}
                                                value={fournisseurOptions.find(option => option.value === filters.fournisseurId)}
                                                onChange={(option) => handleSupplierChange(option?.value)}
                                                placeholder="Sélectionner..."
                                                isClearable
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                                menuPortalTarget={typeof window !== 'undefined' ? document.body : null}
                                                styles={{
                                                    menuPortal: base => ({ ...base, zIndex: 9999 })
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="monthFilter" className="mb-1">Mois</Label>
                                            <Input
                                                type="month"
                                                id="monthFilter"
                                                value={filters.month}
                                                onChange={e => handleMonthChange(e.target.value)}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateFrom" className="mb-1">Date début</Label>
                                            <Input
                                                type="date"
                                                id="dateFrom"
                                                value={filters.dateFrom}
                                                onChange={e => setFilters(f => ({ ...f, month: '', dateFrom: e.target.value, page: 0 }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={2} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="dateTo" className="mb-1">Date fin</Label>
                                            <Input
                                                type="date"
                                                id="dateTo"
                                                value={filters.dateTo}
                                                onChange={e => setFilters(f => ({ ...f, month: '', dateTo: e.target.value, page: 0 }))}
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={3} sm={6} xs={12}>
                                        <FormGroup className="mb-0">
                                            <Label for="paymentStatus" className="mb-1">
                                                {t('reglement.paymentState')}
                                            </Label>
                                            <Input
                                                type="select"
                                                id="paymentStatus"
                                                value={filters.paymentStatus}
                                                onChange={e => setFilters(f => ({ ...f, paymentStatus: e.target.value, page: 0 }))}
                                            >
                                                <option value="">{t('common.all', 'Tous')}</option>
                                                <option value="PAYE">{t('reglement.paye')}</option>
                                                <option value="PARTIEL">{t('reglement.partiel')}</option>
                                                <option value="IMPAYE">{t('reglement.impaye')}</option>
                                            </Input>
                                        </FormGroup>
                                    </Col>
                                    <Col lg={1} md={1} sm={6} xs={12} className="d-flex align-items-end">
                                        <Button
                                            color="secondary"
                                            onClick={clearFilters}
                                            title={t('common.clearFilters')}
                                            className="reception-clear-filters"
                                            style={{ minHeight: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                        >
                                            <FaFilter />
                                        </Button>
                                    </Col>
                                </Row>
                            </div>

		                            <DocumentPagination
		                                pageNumber={pageNumber}
		                                totalPages={totalPages}
		                                totalElements={totalElements}
		                                pageSize={pageSize}
		                                onPageChange={(page) => setFilters(f => ({ ...f, page }))}
		                            />
		                            <div className="doc-list">
	                                {filteredReceiptNotes.length > 0 && (
	                                    <div className="doc-row doc-row-total" style={{ gridTemplateColumns: '48px minmax(220px, 1.2fr) minmax(180px, 1fr) minmax(210px, 1fr) minmax(150px, auto) auto' }}>
	                                        <div className="text-center">
	                                            <Input
	                                                type="checkbox"
	                                                onChange={(e) => setCheckedReceptions(e.target.checked ? selectableFilteredReceiptIds : [])}
	                                                checked={
	                                                    checkedReceptions.length > 0 &&
	                                                    selectableFilteredReceiptIds.length > 0 &&
	                                                    selectableFilteredReceiptIds.every(id => checkedReceptions.includes(id))
	                                                }
	                                            />
	                                        </div>
	                                        <div className="doc-row-main">
	                                            <span className="doc-title">{t('common.totals')}</span>
	                                            <span className="doc-subtitle">{filteredReceiptNotes.length} {t('reception.receptions', 'receptions')}</span>
	                                        </div>
	                                        <div />
	                                        <div className="doc-amounts">
	                                            <div>
	                                                <span>{t('reception.totalTtc')}</span>
	                                                <strong>{formatPrice(filteredReceiptNotes.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</strong>
	                                            </div>
	                                            <div>
	                                                <span>{t('reglement.montantPaye')}</span>
	                                                <strong>{formatPrice(filteredReceiptNotes.reduce((sum, bl) => sum + (bl.montantRegle || 0), 0), false)}</strong>
	                                            </div>
	                                        </div>
	                                        <div />
	                                        <div />
	                                    </div>
	                                )}
	                                {filteredReceiptNotes.map((note) => (
	                                    <div className={`doc-row ${getPaymentRowClass(note)}`} key={note.id} style={{ gridTemplateColumns: '48px minmax(220px, 1.2fr) minmax(180px, 1fr) minmax(210px, 1fr) minmax(150px, auto) auto' }}>
	                                        <div className="text-center">
	                                            {note.statut === 'VALIDE' && !note.facture && (
	                                                <Input
	                                                    type="checkbox"
	                                                    checked={checkedReceptions.includes(note.id)}
	                                                    onChange={() => handleCheckboxChange(note.id)}
	                                                />
	                                            )}
	                                        </div>
	                                        <div className="doc-row-main">
	                                            <span className="doc-title">{note.numero}</span>
	                                            <span className="doc-subtitle">{t('reception.purchaseOrderNumber')}: {note.commandeNumero || '-'}</span>
	                                            <span className="doc-subtitle">{t('reception.deliveryNoteNb')}: {note.deliveryNoteNb || '-'}</span>
	                                            <span className="doc-subtitle">{t('reception.receiptDate')}: {note?.dateReception || '-'}</span>
	                                        </div>
	                                        <div className="doc-client">
	                                            <strong>{note.fournisseurNom || '-'}</strong>
	                                            <span>{note.fournisseurCode || '-'}</span>
	                                            <span>{t('reception.entrepot')}: {note.entrepotNom || '-'}</span>
	                                        </div>
	                                        <div className="doc-amounts">
	                                            <div>
	                                                <span>{t('reception.totalTtc')}</span>
	                                                <strong>{formatPrice(note.montantTotalTTC, false)}</strong>
	                                            </div>
	                                            <div>
	                                                <span>{t('reglement.montantPaye')}</span>
	                                                <strong>{formatPrice(note.montantRegle, false)}</strong>
	                                            </div>
	                                        </div>
	                                        <div className="doc-statuses">
	                                            {getPaymentBadge(note)}
	                                            {getStatusBadge(note.statut)}
	                                            <Badge color={note.facture ? 'success' : 'secondary'}>
	                                                {t('delivery.facture')}: {note.facture ? t('common.yes', 'Oui') : t('common.no', 'Non')}
	                                            </Badge>
	                                        </div>
	                                        <div className="doc-actions">
	                                            <CancelDocumentButton document={note} endpoint={`/api/receipt-notes/${note.id}/annuler`} onCancelled={() => { setCheckedReceptions(current => current.filter(id => id !== note.id)); refreshReceiptNotes(); }} />
	                                            {note.statut === 'EN_ATTENTE' && (
	                                                <Button
	                                                    color="success"
	                                                    title={t('devis.devisValide')}
	                                                    onClick={() => handleValidate(note)}
	                                                    size="sm"
	                                                    className="doc-icon-btn"
	                                                >
	                                                    <FaCheckCircle />
	                                                </Button>
	                                            )}
	                                            <UncontrolledDropdown>
	                                                <DropdownToggle caret color="secondary" size="sm" className="doc-icon-btn">
	                                                    <FaFilePdf />
	                                                </DropdownToggle>
	                                                <DropdownMenu>
	                                                    <DropdownItem
	                                                        onClick={() =>
	                                                            generateReceptionLikePdfMake(note, {
	                                                                docType: "BON DE RÃ‰CEPTION",
	                                                                showPrices: true,
	                                                                priceMode: "TTC",
	                                                                company,
	                                                            })
	                                                        }
	                                                    >
	                                                        {t('reception.pdfWithPrices')}
	                                                    </DropdownItem>
	                                                    <DropdownItem
	                                                        onClick={() =>
	                                                            generateReceptionLikePdfMake(note, {
	                                                                docType: "BON DE RÃ‰CEPTION",
	                                                                showPrices: false,
	                                                                company,
	                                                            })
	                                                        }
	                                                    >
	                                                        {t('reception.pdfWithoutPrices')}
	                                                    </DropdownItem>
	                                                </DropdownMenu>
	                                            </UncontrolledDropdown>
	                                            <Button color="warning" title="Consulter" onClick={() => {
	                                                navigate(RECEPTION_FORM_PAGE, { state: { reception: note } });
	                                            }} size="sm" className="doc-icon-btn">
	                                                <FaEdit size={12} />
	                                            </Button>

	                                        </div>
	                                    </div>
	                                ))}
	                                {filteredReceiptNotes.length === 0 && (
	                                    <div className="doc-empty">{t('reception.noRC')}</div>
	                                )}
	                            </div>
		                            <table className="table table-hover table-striped table-bordered d-none" style={{ fontSize: '0.8rem' }}>
                                <thead className="thead-light">
                                    <tr>
                                        <th className="align-middle text-center" width="20">
                                            <div className="form-check">
                                                <Input
                                                    type="checkbox"
                                                    onChange={(e) => {
                                                        if (e.target.checked) {
                                                            // Only select deliveries that are in LIVRE status
                                                            setCheckedReceptions(selectableFilteredReceiptIds);
                                                        } else {
                                                            setCheckedReceptions([]);
                                                        }
                                                    }}
                                                    checked={
                                                        checkedReceptions.length > 0 &&
                                                        selectableFilteredReceiptIds.length > 0 &&
                                                        selectableFilteredReceiptIds.every(id => checkedReceptions.includes(id))
                                                    }
                                                />
                                            </div>
                                        </th>
                                        <th className="align-middle text-center">{t('reception.receiptNumber')}</th>
                                        <th className="align-middle text-center">{t('reception.purchaseOrderNumber')}</th>
                                        <th className="align-middle text-center">{t('reception.deliveryNoteNb')}</th>
                                        {/* <th className="align-middle text-center">{t('purchase.dateCreation')}</th>
                                        <th className="align-middle text-center">{t('purchase.dateModification')}</th> */}
                                        <th className="align-middle text-center">{t('reception.receiptDate')}</th>
                                        <th className="align-middle text-center">{t('reception.supplier')}</th>
                                        <th className="align-middle text-center">{t('reception.entrepot')}</th>
                                        <th className="align-middle text-center">{t('reception.totalTtc')}</th>
                                        <th className="align-middle text-center">{t('reglement.montantPaye')}</th>
                                        <th className="align-middle text-center">{t('delivery.regle')}</th>
                                        <th className="align-middle text-center">{t('delivery.facture')}</th>
                                        <th className="align-middle text-center">{t('reception.status')}</th>
                                        <th className="align-middle text-center">{t('common.actions')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredReceiptNotes.map((note) => (
                                        <tr key={note.id} className={getPaymentRowClass(note)}>
                                            <td className="align-middle text-center">
                                                {note.statut === 'VALIDE' && !note.facture && (
                                                    <Input
                                                        type="checkbox"
                                                        checked={checkedReceptions.includes(note.id)}
                                                        onChange={() => handleCheckboxChange(note.id)}
                                                    />
                                                )}
                                            </td>
                                            <td className="align-middle text-center">{note.numero}</td>
                                            <td className="align-middle text-center">{note.commandeNumero}</td>
                                            <td className="align-middle text-center">{note.deliveryNoteNb}</td>
                                            {/* <td className="align-middle text-center">{note.createdAt}</td>
                                            <td className="align-middle text-center">{note.updatedAt}</td> */}
                                            <td className="align-middle text-center">{note?.dateReception}</td>
                                            <td className="align-middle text-center">{note.fournisseurNom} ({note.fournisseurCode})</td>
                                            <td className="align-middle text-center">{note.entrepotNom}</td>
                                            <td className="align-middle text-center">{formatPrice(note.montantTotalTTC, false)}</td>
                                            <td className="align-middle text-center">{formatPrice(note.montantRegle, false)}</td>
                                            <td className="align-middle text-center">
                                                {getPaymentBadge(note)}
                                            </td>
                                            {/* Add facture status column */}
                                            <td className="align-middle text-center">
                                                <input
                                                    type="checkbox"
                                                    checked={note.facture}
                                                    readOnly
                                                />
                                            </td>
                                            <td className="align-middle text-center">
                                                {getStatusBadge(note.statut)}
                                            </td>
                                            <td className="align-middle text-center">
                                                <div className="btn-group">
                                                    {note.statut === 'EN_ATTENTE' && <Button
                                                        color="success"
                                                        title={t('devis.devisValide')}
                                                        onClick={() => handleValidate(note)}
                                                        className='me-1'
                                                        size="sm"
                                                    >
                                                        <FaCheckCircle />
                                                    </Button>}

                                                    <UncontrolledDropdown>
                                                        <DropdownToggle caret color="secondary" size="sm" className="me-1">
                                                            <FaFilePdf />
                                                        </DropdownToggle>

                                                        <DropdownMenu>
                                                            {/* PDF WITH PRICES */}
                                                            <DropdownItem
                                                                onClick={() =>
                                                                    generateReceptionLikePdfMake(note, {
                                                                        docType: "BON DE RÉCEPTION",
                                                                        showPrices: true,
                                                                        priceMode: "TTC",
                                                                        company,
                                                                    })
                                                                }
                                                            >
                                                                {t('reception.pdfWithPrices')}
                                                            </DropdownItem>

                                                            {/* PDF WITHOUT PRICES */}
                                                            <DropdownItem
                                                                onClick={() =>
                                                                    generateReceptionLikePdfMake(note, {
                                                                        docType: "BON DE RÉCEPTION",
                                                                        showPrices: false,
                                                                        company,
                                                                    })
                                                                }
                                                            >
                                                                {t('reception.pdfWithoutPrices')}
                                                            </DropdownItem>
                                                        </DropdownMenu>
                                                    </UncontrolledDropdown>


                                                    <Button color="warning" title='Consulter' onClick={() => {
                                                        navigate(RECEPTION_FORM_PAGE, { state: { reception: note } });
                                                    }} size="sm" className="px-2 py-1">
                                                        <FaEdit size={12} className="mr-2" />
                                                    </Button>
                                                    <CancelDocumentButton document={note} endpoint={`/api/receipt-notes/${note.id}/annuler`} onCancelled={() => { setCheckedReceptions(current => current.filter(id => id !== note.id)); refreshReceiptNotes(); }} />
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                    {filteredReceiptNotes.length === 0 && (
                                        <tr>
                                            <td colSpan="13" className="text-center py-4">
                                                <div className="text-muted">{t('reception.noRC')}</div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                                <tfoot>
                                    <tr className="bg-light fw-bold">
                                        <td colSpan="7" className="text-end">{t('common.totals')}</td>
                                        <td className="text-center">{formatPrice(filteredReceiptNotes.reduce((sum, bl) => sum + (bl.montantTotalTTC || 0), 0), false)}</td>
                                        <td className="text-center">{formatPrice(filteredReceiptNotes.reduce((sum, bl) => sum + (bl.montantRegle || 0), 0), false)}</td>
                                        <td colSpan="4"></td>
                                    </tr>
                                </tfoot>

                            </table>

                        </>)}
                </CardBody>
            </Card>
            <Modal isOpen={showInvoiceModal} toggle={handleCloseInvoiceModal} size="xl">
                <ModalHeader toggle={handleCloseInvoiceModal}>
                    {t('facture.newInvoice')}
                </ModalHeader>
                <ModalBody>
                    {invoice && (
                        <InvoiceForm
                            initialValues={invoice}
                            onClose={handleCloseInvoiceModal}
                        />
                    )}
                </ModalBody>
            </Modal>
        </Container>
    );
}

export default ReceptionPage;
